import { render } from "./ParentFinancialProfile.vue?vue&type=template&id=79d364be&scoped=true"
import script from "./ParentFinancialProfile.vue?vue&type=script&lang=js"
export * from "./ParentFinancialProfile.vue?vue&type=script&lang=js"

import "./ParentFinancialProfile.vue?vue&type=style&index=0&id=79d364be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d364be"]])

export default __exports__